export enum UserRole {
  USER = "USER",
  ADMIN = "ADMIN"
}

export interface BaseUser {
  id: string;
  name: string | null;
  email: string | null;
  role: UserRole;
  token: string;
  storageUsed: number;
  storageLimit: number;
}

export interface User extends Required<Pick<BaseUser, 'id' | 'name' | 'email' | 'role' | 'token' | 'storageUsed' | 'storageLimit'>> {}

export interface SessionUser extends BaseUser {
  accessToken: string;
}

export interface AuthResponse {
  user: User;
  token: string;
  error?: string;
}